import { AlertColor, Snackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import * as React from 'react';
import { ReactNode } from 'react';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return (
    <MuiAlert
      sx={{ borderRadius: 24, pr: 2.5 }}
      elevation={6}
      ref={ref}
      variant="filled"
      {...props}
    />
  );
});

interface AlertBoxProps {
  open: boolean;
  onClose: () => void;
  autoHideDuration: number;
  severity: AlertColor;
  children: ReactNode;
}

export default function AlertBox({
  open,
  onClose,
  autoHideDuration,
  severity,
  children
}: AlertBoxProps) {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <Alert onClose={onClose} variant="standard" severity={severity}>
        {children}
      </Alert>
    </Snackbar>
  );
}
